import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location){
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/dataroom/login',
      component: () => import('../views/login/index')
    },
    {
      path: '/dataroom/login',
      name: 'login',
      component: () => import('../views/login/index')
    },
    {
      path: '/dataroom',
      alias: '/dir',
      name: 'directory',
      component: () => import('../views/directory/newIndex')
    },
    {
      path: '/dataroom/users',
      alias: '/user',
      name: 'user',
      component: () => import('../views/user/index')
    },
    {
      path: '/dataroom/files/:dir_name/:dir_id',
      name: 'files',
      component: () => import('../views/files/index')
    },
    {
      path: '/dataroom/files',
      name: 'files',
      component: () => import('../views/files/index')
    },
    {
      path: '/dataroom/files/:file_id',
      name: 'files',
      component: () => import('../views/files/viewFile')
    },
    {
      path: '/dataroom/agreement',
      component: () => import('../views/agreement/index')
    },
    {
      path: '/dataroom/manage',
      component: () => import('../views/adminHome/index')
    },
    {
      path: '/dataroom/manage/:page',
      component: () => import('../views/adminHome/index')
    },
    {
      path: '/404',
      component: () => import('../views/error/index')
    },

    {
      path: '/dataroom/signup',
      name: 'signup',
      component: () => import('../views/signup/index')
    },
    // {
    //   path: '*',
    //   redirect: '/404'
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js